class ReactFilterText extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isActive: false,
            isExpanded: false,
            value: props.settings.value
        };

        this.filterRef = React.createRef(null);
        this.dropdownListRef = React.createRef(null);
    }

    componentDidMount() {
        document.addEventListener('click', this.onDocumentClick.bind(this))
    }

    componentWillMount() {
        document.removeEventListener('click', this.onDocumentClick.bind(this))
    }

    onDocumentClick(event) {
        var clickedOutside = this.filterRef.current && this.filterRef.current !== event.target && !this.filterRef.current.contains(event.target);
        if(this.dropdownListRef.current && this.dropdownListRef.current.style.display !== 'none' && clickedOutside){
            this.setState({
                isExpanded: false,
            });
        }
    }

    /**
     * Called by the grid, should return the data to be sent to the ajax.
     * @returns Object
     */
    getValues() {
        this.setState({isActive: !!this.state.value});
        return {value: this.state.value};
    }

    /**
     * Called by the grid, should set new values
     * @returns Object
     */
    setValues(values) {
        this.setState(values);
    }

    /**
     * Called by the grid, should reset it's values to the defaults.
     */
    clearValues() {
        this.setState({
            isActive: false,
            value: null
        });
    }

    clearFilter() {
        this.clearValues();
        if (this.props.loadGrid) {
            setTimeout(function () {
                this.props.loadGrid();
            }.bind(this), 50);
        }
    }

    togglePopup() {
        this.setState({
            isExpanded: !this.state.isExpanded
        });
    }

    handleFilterButtons(event) {
        this.setState({
            isExpanded: false
        });

        if (event.target.dataset.button == "apply") {
            this.props.applyFilters();
        }
        if (event.target.dataset.button == "clear") {
            this.props.clearFilters();
        }
    }

    onValueChange(event) {
        this.setState({value: event.target.value});
    }

    onKeyUp(event) {
        if (event.which == 13) { // search on ENTER
            if (this.props.loadGrid) {
                this.props.loadGrid();

                this.setState({
                    isExpanded: false
                });
            }
        }
    }

    render() {
        var type = this.props.settings.type;

        var placeholder = type == 'contains' ? __d('modules','Contains') : __d('modules','Exact Match');

        var holderCls = 'btn-group custom-dropdown-wrapper text-filter-wrapper';
        if (this.state.isActive) {
            holderCls += ' active';
        }
        if (this.state.isExpanded) {
            holderCls += ' expanded';
        }

        var buttons = null;
        if (this.props.applyFilters && this.props.clearFilters) {
            buttons = (
                <div className="grid-filter-actions">
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="apply" className="btn btn-primary apply-filter"
                       role="button">{__d('modules','Apply')}</a>
                    <a onClick={this.handleFilterButtons.bind(this)} data-button="clear" className="btn btn-link clear-filter"
                       role="button">{__d('modules','Reset')}</a>
                </div>
            );
        }

        return (
            <div className={holderCls} ref={this.filterRef}>
                <div className="custom-dropdown-button">
                    <button type="button" className="btn btn-primary dropdown-toggle custom-dropdown-toggle"
                            onClick={this.togglePopup.bind(this)} data-toggle="custom-dropdown"
                            aria-haspopup="true" aria-expanded="false">
                        {this.props.label}
                    </button>
                </div>
                <div className="custom-dropdown-clear-button">
                    <button type="button" className="btn btn-primary clear-filter" onClick={this.clearFilter.bind(this)}><i/>
                    </button>
                </div>
                <div className="card custom-dropdown-popup" ref={this.dropdownListRef}>
                    <div className="card-block">
                        <div className="content">
                            <div className="field-holder">
                                <input type="text" placeholder={placeholder} onChange={this.onValueChange.bind(this)}
                                       onKeyUp={this.onKeyUp.bind(this)} value={this.state.value}/>
                            </div>
                            {buttons}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

ReactFilterText.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    settings: PropTypes.shape({
        type: PropTypes.string,
        value: PropTypes.string
    }),
    applyFilters: PropTypes.func,
    clearFilters: PropTypes.func,
    loadGrid: PropTypes.func
};